import type { ApiClient } from '../api/client';
import type { VerifyResponse } from '../api/types';
import type { Wallet } from './wallet';

/**
 * The full wallet sign-in handshake (spec.md §B.1):
 *   1. request a single-use challenge nonce + exact message for this wallet
 *   2. sign the message with the wallet key (off-chain; no gas, no $OBOL)
 *   3. verify the signature → server creates-or-authenticates the account + issues
 *      a stateless Bearer session token
 *
 * Pure orchestration over the injected client + wallet, so it is fully unit-testable.
 */
export async function authenticate(wallet: Wallet, client: ApiClient): Promise<VerifyResponse> {
  const { nonce, message } = await client.nonce(wallet.address);
  const signature = await wallet.signMessage(message);
  return client.verify({ wallet: wallet.address, signature, nonce });
}
